<script setup lang="ts">
import { ChevronRight } from 'lucide-vue-next'

import { REGISTRATION_STEPS } from '../../../lib/brandAppSections'

const { t } = useI18n()

const props = defineProps<{
  hasFormCompletion: boolean
}>()

const emit = defineEmits<{
  open: [id: string]
}>()

const OPTIONAL_STEP_ID = 'reg-profile'

const steps = computed(() => {
  let position = 0

  return REGISTRATION_STEPS.map((step) => {
    const isOptional = step.id === OPTIONAL_STEP_ID
    const isSkipped = isOptional && !props.hasFormCompletion
    if (!isSkipped) position += 1

    return { ...step, isOptional, isSkipped, position: isSkipped ? null : position }
  })
})
</script>

<template>
  <div class="flex flex-col gap-2 px-6">
    <p class="text-foreground-secondary mb-2 text-sm leading-relaxed">
      {{ t('pages.loyaltySupports.webapp.editor.loyalty.stepsIntro') }}
    </p>
    <Button
      v-for="(step, index) in steps"
      :key="step.id"
      type="button"
      variant="outline"
      class="hover:border-foreground-disabled motion-safe:animate-card-in h-auto justify-start gap-3 p-3 text-left font-normal transition-colors"
      :class="step.isSkipped ? 'bg-muted/50' : 'bg-background shadow-surface'"
      :style="{ animationDelay: `${Math.min(index, 5) * 40}ms` }"
      @click="emit('open', step.id)"
    >
      <span
        class="border-border bg-background flex size-7 shrink-0 items-center justify-center rounded-full border text-xs font-semibold tabular-nums"
        :class="step.isSkipped ? 'text-foreground-disabled' : 'text-foreground-secondary'"
      >
        {{ step.position ?? '–' }}
      </span>
      <span
        class="min-w-0 truncate text-sm font-medium"
        :class="step.isSkipped ? 'text-foreground-secondary' : 'text-foreground'"
      >
        {{ step.name }}
      </span>
      <BaseChip
        v-if="step.isOptional"
        :text="
          step.isSkipped
            ? t('pages.loyaltySupports.webapp.editor.loyalty.stepDisabled')
            : t('pages.loyaltySupports.webapp.editor.loyalty.stepEnabled')
        "
        :color="step.isSkipped ? 'gray' : 'green'"
        class="ml-auto shrink-0"
      />
      <ChevronRight class="text-foreground-disabled size-4 shrink-0" :class="{ 'ml-auto': !step.isOptional }" />
    </Button>
  </div>
</template>
